import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getFormValues } from 'redux-form';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import api from '../../../core/api';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { LoadersNames } from '../../ui/ui.constants';
import {
  createHerdManagementSystem,
  deleteHerdManagementSystem,
  editHerdManagementSystem,
  getHerdManagementSystem,
} from './hms.actions';
import { Forms } from '../../form/form.selector';
import { notificationSuccess } from '../../../core/helpers/utils/notificationUtils';
import { compose403ErrorMessage, successHandler } from '../../../core/helpers/utils/sagaUtils';

export function* getHerdManagementSystemSaga() {
  yield put(showLoader(LoadersNames.getHerdManagementSystem));
  try {
    const result = yield call(api.hms.getHMS);

    yield put(
      getHerdManagementSystem.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    composeErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.getHerdManagementSystem));
}

export function* createHerdManagementSystemSaga(action: ReturnType<typeof createHerdManagementSystem.started>) {
  const { hmsName, groupId } = yield select(getFormValues(Forms.herdManagementSystemForm));
  const formName = action.payload;
  try {
    const result = yield call(api.hms.createHMS, { hmsName, groupId }, formName);

    yield put(
      createHerdManagementSystem.done({
        params: action.payload,
        result,
      }),
    );
    yield put(notificationSuccess('hms:create_herd_maangement_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* editHerdManagementSystemSaga(action: ReturnType<typeof editHerdManagementSystem.started>) {
  const { id, formName } = action.payload;
  const { hmsName, groupId } = yield select(getFormValues(Forms.herdManagementSystemForm));

  try {
    const result = yield call(api.hms.editHMS, id, { hmsName, groupId }, formName);

    yield put(
      editHerdManagementSystem.done({
        params: action.payload,
        result,
      }),
    );
    yield put(notificationSuccess('hms:edit_herd_maangement_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* deleteHerdManagementSystemSaga(action: ReturnType<typeof deleteHerdManagementSystem.started>) {
  const { id, formName } = action.payload;
  try {
    yield call(api.hms.deleteHMS, id, formName);

    yield put(
      deleteHerdManagementSystem.done({
        params: action.payload,
        result: id,
      }),
    );
    successHandler(action.meta);
    yield put(notificationSuccess('hms:delete_herd_maangement_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* watchHerdManagementSystemSaga() {
  yield all([
    yield takeLatest(getHerdManagementSystem.started, getHerdManagementSystemSaga),
    yield takeLatest(createHerdManagementSystem.started, createHerdManagementSystemSaga),
    yield takeLatest(editHerdManagementSystem.started, editHerdManagementSystemSaga),
    yield takeLatest(deleteHerdManagementSystem.started, deleteHerdManagementSystemSaga),
  ]);
}
